import _asyncToGenerator from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
export default {
  account: function () {
    var _account = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(locale) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return import(
              /* webpackChunkName: "account-copy" */
              "./src/".concat(locale, "/account.json"));

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function account(_x) {
      return _account.apply(this, arguments);
    }

    return account;
  }(),
  ageGate: function () {
    var _ageGate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(locale) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return import(
              /* webpackChunkName: "age-gate-copy" */
              "./src/".concat(locale, "/ageGate.json"));

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function ageGate(_x2) {
      return _ageGate.apply(this, arguments);
    }

    return ageGate;
  }(),
  browse: function () {
    var _browse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(locale) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return import(
              /* webpackChunkName: "browse-copy" */
              "./src/".concat(locale, "/browse.json"));

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function browse(_x3) {
      return _browse.apply(this, arguments);
    }

    return browse;
  }(),
  chooseUsername: function () {
    var _chooseUsername = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(locale) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return import(
              /* webpackChunkName: "choose-username-copy" */
              "./src/".concat(locale, "/chooseUsername.json"));

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function chooseUsername(_x4) {
      return _chooseUsername.apply(this, arguments);
    }

    return chooseUsername;
  }(),
  createAccount: function () {
    var _createAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(locale) {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return import(
              /* webpackChunkName: "create-account-copy" */
              "./src/".concat(locale, "/createAccount.json"));

            case 2:
              return _context5.abrupt("return", _context5.sent);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function createAccount(_x5) {
      return _createAccount.apply(this, arguments);
    }

    return createAccount;
  }(),
  freeTrial: function () {
    var _freeTrial = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(locale) {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return import(
              /* webpackChunkName: "free-trial-copy" */
              "./src/".concat(locale, "/freeTrial"));

            case 2:
              return _context6.abrupt("return", _context6.sent);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function freeTrial(_x6) {
      return _freeTrial.apply(this, arguments);
    }

    return freeTrial;
  }(),
  login: function () {
    var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(locale) {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return import(
              /* webpackChunkName: "login-copy" */
              "./src/".concat(locale, "/login.json"));

            case 2:
              return _context7.abrupt("return", _context7.sent);

            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    function login(_x7) {
      return _login.apply(this, arguments);
    }

    return login;
  }(),
  profile: function () {
    var _profile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(locale) {
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return import(
              /* webpackChunkName: "profile-copy" */
              "./src/".concat(locale, "/profile.json"));

            case 2:
              return _context8.abrupt("return", _context8.sent);

            case 3:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    function profile(_x8) {
      return _profile.apply(this, arguments);
    }

    return profile;
  }(),
  welcome: function () {
    var _welcome = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(locale) {
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return import(
              /* webpackChunkName: "welcome-copy" */
              "./src/".concat(locale, "/welcome.json"));

            case 2:
              return _context9.abrupt("return", _context9.sent);

            case 3:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    function welcome(_x9) {
      return _welcome.apply(this, arguments);
    }

    return welcome;
  }(),
  resetPassword: function () {
    var _resetPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(locale) {
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return import(
              /* webpackChunkName: "resetPassword-copy" */
              "./src/".concat(locale, "/resetPassword.json"));

            case 2:
              return _context10.abrupt("return", _context10.sent);

            case 3:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    function resetPassword(_x10) {
      return _resetPassword.apply(this, arguments);
    }

    return resetPassword;
  }(),
  subscription: function () {
    var _subscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(locale) {
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return import(
              /* webpackChunkName: "subscription-copy" */
              "./src/".concat(locale, "/subscription.json"));

            case 2:
              return _context11.abrupt("return", _context11.sent);

            case 3:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    function subscription(_x11) {
      return _subscription.apply(this, arguments);
    }

    return subscription;
  }(),
  terms: function () {
    var _terms = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(locale) {
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return import(
              /* webpackChunkName: "terms-copy" */
              "./src/".concat(locale, "/terms.json"));

            case 2:
              return _context12.abrupt("return", _context12.sent);

            case 3:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    function terms(_x12) {
      return _terms.apply(this, arguments);
    }

    return terms;
  }(),
  player: function () {
    var _player = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(locale) {
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return import(
              /* webpackChunkName: "player-copy" */
              "./src/".concat(locale, "/player.json"));

            case 2:
              return _context13.abrupt("return", _context13.sent);

            case 3:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    function player(_x13) {
      return _player.apply(this, arguments);
    }

    return player;
  }(),
  classDetails: function () {
    var _classDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(locale) {
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return import(
              /* webpackChunkName: "classDetails-copy" */
              "./src/".concat(locale, "/classDetails.json"));

            case 2:
              return _context14.abrupt("return", _context14.sent);

            case 3:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    function classDetails(_x14) {
      return _classDetails.apply(this, arguments);
    }

    return classDetails;
  }(),
  global: function () {
    var _global = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(locale) {
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return import(
              /* webpackChunkName: "global-copy" */
              "./src/".concat(locale, "/global.json"));

            case 2:
              return _context15.abrupt("return", _context15.sent);

            case 3:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    function global(_x15) {
      return _global.apply(this, arguments);
    }

    return global;
  }(),
  error: function () {
    var _error = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(locale) {
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return import(
              /* webpackChunkName: "error-copy" */
              "./src/".concat(locale, "/error.json"));

            case 2:
              return _context16.abrupt("return", _context16.sent);

            case 3:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }));

    function error(_x16) {
      return _error.apply(this, arguments);
    }

    return error;
  }(),
  resetPasswordConfirmation: function () {
    var _resetPasswordConfirmation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(locale) {
      return _regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return import(
              /* webpackChunkName: "resetPasswordConfirmation-copy" */
              "./src/".concat(locale, "/resetPasswordConfirmation.json"));

            case 2:
              return _context17.abrupt("return", _context17.sent);

            case 3:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));

    function resetPasswordConfirmation(_x17) {
      return _resetPasswordConfirmation.apply(this, arguments);
    }

    return resetPasswordConfirmation;
  }()
};